"use client";

import {
  API_KEY,
  ENVIRONMENT,
  config,
  WALLET_CONNECT_PROJECT_ID,
} from "@/constants";
import { ParaProvider as Provider } from "@getpara/react-sdk";

export function ParaProvider({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <Provider
      paraClientConfig={{
        apiKey: API_KEY,
        env: ENVIRONMENT,
      }}
      externalWalletConfig={{
        wallets: ["METAMASK", "OKX", "WALLETCONNECT"],
        evmConnector: {
          config: config,
        },
        walletConnect: {
          projectId: WALLET_CONNECT_PROJECT_ID,
        },
      }}
      config={{ appName: "Camp" }}
      paraModalConfig={{
        disableEmailLogin: false,
        disablePhoneLogin: false,
        authLayout: ["AUTH:FULL", "EXTERNAL:FULL"],
        oAuthMethods: ["GOOGLE", "TWITTER"],
        onRampTestMode: true,
        theme: {
          font: "Inter",
          borderRadius: "none",
          accentColor: "#FF5101",
          backgroundColor: "#F9F7F4",
          foregroundColor: "#FF6D01",
        },
        logo: "/assets/camp-token.png",
        recoverySecretStepEnabled: true,
        twoFactorAuthEnabled: false,
      }}>
      {children}
    </Provider>
  );
}
